import React from 'react';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { ClassroomsContext } from './context';

interface Props {
  classrooms: Classroom[];
  children?: React.ReactNode;
}

export default function ManualClassroomsProvider(props: Props) {
  const { classrooms } = props;
  return <ClassroomsContext.Provider value={classrooms} {...props} />;
}
